export default {
  en: [
    {
      dl: "Car_Preference",
      i: "preference",
      q: "Choose your car preference.",
      a: [
        "Please Select",
        "Midsize",
        "Fullsize",
        "Compact",
        "Standard",
        "Midsize SUV",
        "Standard SUV",
        "Minivan",
        "Economy",
        "Premium",
        "Fullsize SUV"
      ],
      v: [
        "",
        "Midsize",
        "Fullsize",
        "Compact",
        "Standard",
        "Midsize SUV",
        "Standard SUV",
        "Minivan",
        "Economy",
        "Premium",
        "Fullsize SUV"
      ]
    },
    {
      dl: "How_Often",
      i: "often",
      q: "How often do you plan to travel internationally?",
      a: [
        "Please Select",
        "Once a year",
        "Twice a year",
        "3 times a year",
        "More than 4 times a year"
      ],
      v: ["", "1", "2", "3", "4+"]
    },
    {
      dl: "Main_Purpose",
      i: "purpose",
      q: "What's your main purpose for traveling?",
      a: ["Please Select", "Business", "Leisure"],
      v: ["", "Business", "Leisure"]
    },
    {
      dl: "Country_Origin",
      i: "country",
      q: "What's your country of origin?",
      a: [
        "Please Select",
        "Antigua",
        "Argentina",
        "Anguilla ",
        "Aruba",
        "Bahamas",
        "Barbados",
        "Bermuda",
        "Bolivia",
        "Bonaire",
        "Belize",
        "Brazil",
        "British Virgin Islands",
        "Cayman Islands",
        "Chile",
        "Colombia",
        "Costa Rica",
        "Curacao",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "El Salvador",
        "Falkland Islands",
        "French Guyana",
        "Granada",
        "Guadeloupe",
        "Guatemala",
        "Guyana",
        "Haiti",
        "Honduras",
        "Jamaica",
        "Martinique",
        "Mexico",
        "Montserrat",
        "Nicaragua",
        "Peru",
        "Paraguay",
        "Panama",
        "Puerto Rico",
        "San Vincent & Grenadines",
        "St.Barthelemy",
        "St.Kitts & St.Nevis ",
        "St.Lucia",
        "St.Maarten(Dutch)",
        "St.Martin(French)",
        "Suriname",
        "Trinidad & Tobago",
        "Turks & Caicos",
        "Uruguay",
        "US Virgin Islands",
        "Venezuela",
        "Other"
      ],
      v: [
        "",
        "AG",
        "AR",
        "AI",
        "AW",
        "BS",
        "BB",
        "BM",
        "BO",
        "BQ",
        "BZ",
        "BR",
        "VG",
        "KY",
        "CL",
        "CO",
        "CR",
        "CW",
        "DM",
        "DO",
        "EC",
        "SV",
        "FK",
        "GF",
        "GD",
        "GP",
        "GT",
        "GY",
        "HT",
        "HN",
        "JM",
        "MQ",
        "MX",
        "MS",
        "NI",
        "PE",
        "PY",
        "PA",
        "PR",
        "VC",
        "BL",
        "KN",
        "LC",
        "SX",
        "MF",
        "SR",
        "TT",
        "TC",
        "UY",
        "VI",
        "VE",
        "OTHER"
      ]
    }
  ],
  es: [
    {
      dl: "Car_Preference",
      i: "preference",
      q: "Elija sus preferencias en los autos. ",
      a: [
        "Por Favor Seleccione",
        "Intermedio",
        "Grande ",
        "Compacto",
        "Estándar",
        "Todo Terreno Intermedio",
        "Todo Terreno Estándar",
        "Minivan ",
        "Económico",
        "Premium",
        "Todo Terreno Grande"
      ],
      v: [
        "",
        "Midsize",
        "Fullsize",
        "Compact",
        "Standard",
        "Midsize SUV",
        "Standard SUV",
        "Minivan",
        "Economy",
        "Premium",
        "Fullsize SUV"
      ]
    },
    {
      dl: "How_Often",
      i: "often",
      q: "¿Cuán seguido viaja internacionalmente?",
      a: [
        "Por Favor Seleccione",
        "Una vez al año",
        "Dos veces al año",
        "Tres veces al año",
        "Más de cuatro veces al año"
      ],
      v: ["", "1", "2", "3", "4+"]
    },
    {
      dl: "Main_Purpose",
      i: "purpose",
      q: "¿Cuál es su propósito para viajar?",
      a: ["Por Favor Seleccione", "Negocios", "Placer"],
      v: ["", "Business", "Leisure"]
    },
    {
      dl: "Country_Origin",
      i: "country",
      q: "¿Cuál es su país de origen?",
      a: [
        "Por Favor Seleccione",
        "Antigua",
        "Argentina",
        "Anguila",
        "Aruba",
        "Bahamas",
        "Barbados",
        "Islas Bermudas",
        "Bolivia",
        "Bonaire",
        "Belice",
        "Brasil",
        "Islas Vírgenes Británicas",
        "Islas Caimán",
        "Chile",
        "Colombia",
        "Costa Rica",
        "Curazao",
        "Dominica",
        "República Dominicana",
        "Ecuador",
        "El Salvador",
        "Islas Malvinas",
        "Guyana Francesa",
        "Granada",
        "Guadalupe",
        "Guatemala",
        "Guayana",
        "Haití",
        "Honduras",
        "Jamaica",
        "Martinica",
        "México",
        "Montserrat",
        "Nicaragua",
        "Perú",
        "Paraguay",
        "Panamá",
        "Puerto Rico",
        "San Vicente y Las Granadinas",
        "San Bartolomé",
        "San Cristóbal y San Nevis",
        "Santa Lucía",
        "San Martín(holandés)",
        "San Martín(francés)",
        "Surinam",
        "Trinidad y Tobago",
        "Turcos y Caicos",
        "Uruguay",
        "Islas Vírgenes de EE.UU.",
        "Venezuela",
        "Otro"
      ],
      v: [
        "",
        "AG",
        "AR",
        "AI",
        "AW",
        "BS",
        "BB",
        "BM",
        "BO",
        "BQ",
        "BZ",
        "BR",
        "VG",
        "KY",
        "CL",
        "CO",
        "CR",
        "CW",
        "DM",
        "DO",
        "EC",
        "SV",
        "FK",
        "GF",
        "GD",
        "GP",
        "GT",
        "GY",
        "HT",
        "HN",
        "JM",
        "MQ",
        "MX",
        "MS",
        "NI",
        "PE",
        "PY",
        "PA",
        "PR",
        "VC",
        "BL",
        "KN",
        "LC",
        "SX",
        "MF",
        "SR",
        "TT",
        "TC",
        "UY",
        "VI",
        "VE",
        "OTHER"
      ]
    }
  ],
  pt: [
    {
      dl: "Car_Preference",
      i: "preference",
      q: "Escolha suas preferências nos carros.",
      a: [
        "Por Favor Selecione",
        "Médio",
        "Grande",
        "Compacto",
        "Standard",
        "4X4 Médio",
        "4X4 Standard",
        "Minivan",
        "Econômico",
        "Premium",
        "4X4 Grande"
      ],
      v: [
        "",
        "Midsize",
        "Fullsize",
        "Compact",
        "Standard",
        "Midsize SUV",
        "Standard SUV",
        "Minivan",
        "Economy",
        "Premium",
        "Fullsize SUV"
      ]
    },
    {
      dl: "How_Often",
      i: "often",
      q: "Quantas vezes você faz uma viagem internacional?",
      a: [
        "Por Favor Selecione",
        "Uma vez por ano",
        "Duas vezes ao ano",
        "Três vezes ao ano",
        "Mais de quatro vezes por ano"
      ],
      v: ["", "1", "2", "3", "4+"]
    },
    {
      dl: "Main_Purpose",
      i: "purpose",
      q: "Qual é o seu propósito para viajar?",
      a: ["Por Favor Selecione", "Negócio", "Lazer"],
      v: ["", "Business", "Leisure"]
    },
    {
      dl: "Country_Origin",
      i: "country",
      q: "Qual é o seu país de origem?",
      a: [
        "Por Favor Selecione",
        "Antígua",
        "Argentina",
        "Anguila",
        "Aruba",
        "Bahamas",
        "Barbados",
        "Bermudas",
        "Bolívia",
        "Bonaire",
        "Belize",
        "Brasil",
        "Ilhas Virgens Britânicas",
        "Ilhas Cayman",
        "Chile",
        "Colômbia",
        "Costa Rica",
        "Curaçao",
        "Dominica",
        "República Dominicana",
        "Equador",
        "El Salvador",
        "Ilhas Falkland",
        "Guiana Francesa",
        "Granada",
        "Guadalupe",
        "Guatemala",
        "Guiana",
        "Haiti",
        "Honduras",
        "Jamaica",
        "Martinica",
        "México",
        "Montserrat",
        "Nicarágua",
        "Peru",
        "Paraguai",
        "Panamá",
        "Porto Rico",
        "São Vicente e Granadinas",
        "São Bartolomeu",
        "São Cristóvão e São Nevis",
        "Santa Lúcia",
        "St.Maarten(holandês)",
        "São Martinho(francês)",
        "Suriname",
        "Trinidad e Tobago",
        "Ilhas Turcas e Caicos",
        "Uruguai",
        "Ilhas Virgens dos EUA",
        "Venezuela",
        "Outro"
      ],
      v: [
        "",
        "AG",
        "AR",
        "AI",
        "AW",
        "BS",
        "BB",
        "BM",
        "BO",
        "BQ",
        "BZ",
        "BR",
        "VG",
        "KY",
        "CL",
        "CO",
        "CR",
        "CW",
        "DM",
        "DO",
        "EC",
        "SV",
        "FK",
        "GF",
        "GD",
        "GP",
        "GT",
        "GY",
        "HT",
        "HN",
        "JM",
        "MQ",
        "MX",
        "MS",
        "NI",
        "PE",
        "PY",
        "PA",
        "PR",
        "VC",
        "BL",
        "KN",
        "LC",
        "SX",
        "MF",
        "SR",
        "TT",
        "TC",
        "UY",
        "VI",
        "VE",
        "OTHER"
      ]
    }
  ]
};
